{
  "score": {
    "trustScore": 4.2,
    "stars": 4
  },
  "numberOfReviews": 137,
  "profileUrl": "https://www.trustpilot.com/review/petprotect.de",
  "reviews": {
    "de": [
      {
        "id": "69cbf795bd2444eee36bc0ff",
        "stars": 1,
        "title": "Lügen und Widerruf wird nicht akzeptiert aber abgebucht!",
        "text": "2Std. Telefonvertrag und Versprechen welche nicht eingehalten wurden. Nach Rücksprache mit dem Tierarzt sind die Ideen der Vermittlerin überhaupt nicht umsetzbar. Anstatt meinen Widerruf zu akzeptieren, mehrere Mails, ausgebliebene Telefonanrufe und Stornierungsmails welche im Nirvana enden, ist nun die erste Abbuchung auf meinem Konto vorgemerkt. Das Unternehmen akzeptiert keinen Widerruf und stellt sich Tod. Nochmal: Was soll ich mit einer Versicherung, welche mein Tier nur absichert wenn ich es Zwangs-Chippen lasse? Der Hinweis, der Chip wird von Ihrem Tierarzt auch ohne Einsetzen ausgehändigt war eine Unwahrheit. Ich soll nun eine Versicherung bezahlen, die ich nicht nutzen kann,  über einen Telefonvertrag geschlossen? Ihr storniert diesen Auftrag und akzeptiert diesen Widerruf oder Verbraucherschutz und sämtliches Social Media inklusive TikTok werden davon erfahren. Ich werde mich wehren und das nicht hinnehmen. Die Zeiten haben sich geändert, einfach Leute abzuzocken und wenn Ihr ein seriöses Unternehmen seid, klärt ihr das in den eigenen Reihen und nicht auf meine Kosten. Sonst werden euch Kunden verloren gehen!\n\nStand 01.04.2026\nDie E-Mail wurde wie gewünscht versendet, mit einem Screenshot dieser Bewertung. Ich werde jetzt auf Ihre Antwort warten. Die unberechtigte Lastschrift, wurde von mir zurückgezogen.\nBin gespannt auf die Antwort ihrer Versicherung.\n\nStand 14.04.2026\nNach einigem hin und her und  der Versand über verschiedene E-Mails, hat sich dann doch jemand eingeschaltet um den Vorgang am Ende mit einer von mir gewünschten Lösung zu klären. \nDer Fairness halber aktualisiere ich die Bewertung um klar zu stellen, das man am Ende doch etwas mit PETPROTECT klären kann. Die Sterne kann ich leider nicht erhöhen, da auch die Lösung  herbeizuführen nicht ganz ohne Widerstand ging. Aber der Vorgang wurde am Ende gelöst. ",
        "consumer": "Missy Stubsi",
        "createdAt": "2026-03-31T18:34:29Z",
        "isVerified": false
      },
      {
        "id": "69a1911543eb9e6e41fb9fa4",
        "stars": 4,
        "title": "Gute Führung durch den Angebotsprozess",
        "text": "Gute Führung durch den Angebotsprozess, allerdings war das Angebot dann nicht herunterladbar und sollte angeblich per EMail verschickt werden. Dennoch muss man anhaken, dass man das Angebot gelesen hat, obwohl man es nicht lesen kann. Das ist natürlich nicht rechtens.",
        "consumer": "Dr. JUF Buschmann",
        "createdAt": "2026-02-27T14:41:57Z",
        "isVerified": false
      },
      {
        "id": "69611d65a11951881c6f2512",
        "stars": 5,
        "title": "schnell am pc von zuhause",
        "text": "schnell am pc von zuhause",
        "consumer": "Maxi",
        "createdAt": "2026-01-09T17:23:17Z",
        "isVerified": true
      },
      {
        "id": "693ff6337cbb8eac61f5eb2a",
        "stars": 5,
        "title": "komplikationsloser Abschluss",
        "text": "problemloser Versicherungsabschluss",
        "consumer": "Norbert Dingemann",
        "createdAt": "2025-12-15T13:51:15Z",
        "isVerified": true
      },
      {
        "id": "692166f8f550fc2f3747cb21",
        "stars": 5,
        "title": "gute leistung zu fairem preis",
        "text": "gute leistung zu fairem preis",
        "consumer": "Fuhrunternehmen Gantke",
        "createdAt": "2025-11-22T09:32:08Z",
        "isVerified": true
      },
      {
        "id": "68f0af4c8cd5c808f25738ce",
        "stars": 5,
        "title": "Einfachheit",
        "text": "Einfache Menüführung und ab dem Tag versichert.",
        "consumer": "Christian Forget",
        "createdAt": "2025-10-16T10:39:40Z",
        "isVerified": true
      },
      {
        "id": "68ef8058d64020cf7e0dd04d",
        "stars": 5,
        "title": "Ganz einfacher Abschluß",
        "text": "Ganz einfacher Abschluß",
        "consumer": "Stephan Linke",
        "createdAt": "2025-10-15T13:07:04Z",
        "isVerified": true
      },
      {
        "id": "68d9562eb2ad4977a004c741",
        "stars": 4,
        "title": "Keine Altersbegrenzung/bessere Leistungen",
        "text": "Es ist absolut von Vorteil dass es keine Altersbegrenzung gibt. Schon der TOP-Tarif bietet wesentlich bessere Leistungen für nur einen geringen Mehrbeitrag (okay, jetzt mit einer Selbstbeteiligung von € 250,00) zu dem Beitrag vom letzten Jahr meiner alten Versicherung, welche den Beitrag zur nächsten Fälligkeit verdoppelt hat. ",
        "consumer": "Langner Silvia",
        "createdAt": "2025-09-28T17:37:18Z",
        "isVerified": true
      },
      {
        "id": "68be0f811f6f78baae287326",
        "stars": 5,
        "title": "Abwicklung ging sehr schnell",
        "text": "Abwicklung ging sehr schnell",
        "consumer": "Renate",
        "createdAt": "2025-09-08T01:04:33Z",
        "isVerified": true
      },
      {
        "id": "68bd30ed72e2e84c42793fd0",
        "stars": 5,
        "title": "Hat Online alles problemlos funktioniert",
        "text": "Hat Online alles problemlos funktioniert ",
        "consumer": "Ire Er",
        "createdAt": "2025-09-07T09:14:53Z",
        "isVerified": true
      },
      {
        "id": "68bad4d058094313efc124d3",
        "stars": 5,
        "title": "Sehr freundliche ausführliche Beratung.",
        "text": "Sehr freundliche ausführliche Beratung. ",
        "consumer": "Barbara Wegmann",
        "createdAt": "2025-09-05T14:17:20Z",
        "isVerified": true
      },
      {
        "id": "68a6d3daef98a9d7864d9c5b",
        "stars": 5,
        "title": "EINFACH, VERSTÄNDLICH UND UNKOMPLIZIERT",
        "text": "SEHR GUTE ERFAHRUNG, EINFACHE UND UNKOMPLIZIERTE HANDHABUNG",
        "consumer": "Christina Reßmeyer",
        "createdAt": "2025-08-21T10:07:54Z",
        "isVerified": true
      },
      {
        "id": "68a6b09a79248066166e9bb1",
        "stars": 5,
        "title": "Einfach",
        "text": "Einfachheit",
        "consumer": "Karin Vibrans",
        "createdAt": "2025-08-21T07:37:31Z",
        "isVerified": true
      },
      {
        "id": "6894b84711776e832347849d",
        "stars": 5,
        "title": "Ein gutes Angebot!",
        "text": "Ein gutes Angebot! Das Prozedere erfolgte reibungslos. Meine einzige Frage wurde sofort und ohne lange Warteschleife beantwortet.",
        "consumer": "ANNELORE",
        "createdAt": "2025-08-07T16:29:27Z",
        "isVerified": true
      },
      {
        "id": "6894935acf4c53c57e454e91",
        "stars": 5,
        "title": "Super",
        "text": "Hat gut geklappt",
        "consumer": "Birgit Schäfer",
        "createdAt": "2025-08-07T13:51:55Z",
        "isVerified": true
      }
    ],
    "en": [
      {
        "id": "669945e47330e184929703fc",
        "stars": 5,
        "title": "Danke good 💯",
        "text": "Danke good 💯",
        "consumer": "Vasile angelin Angelin vasile",
        "createdAt": "2024-07-18T18:42:13Z",
        "isVerified": true
      }
    ]
  },
  "lastUpdatedAt": "2026-05-05T12:15:12.561Z"
}